import {Injectable} from '@angular/core';
import { ToastController } from 'ionic-angular';

/***
 *  Toast 弹出框工具类   
 */
@Injectable()
export class ToastAlert {
  static toastCtrl;
  static toast=null;
  constructor(public toastCtrl: ToastController) {
  	ToastAlert.toastCtrl = this.toastCtrl;
  }
  
  /** 弹出框
    * msg  :弹出框显示信息
    * pst  :显示位置  top middle  bottom 
    * num  : 显示的时间长度  1000 = 1秒
    */
  alertMsg(msg:string,pst: string,num:number){
  	if(ToastAlert.toast!=null){
  		ToastAlert.toast.dismiss().catch(this.handleError);
  		ToastAlert.toast = null;
  	}
	let toast = this.toastCtrl.create({
	    message: msg,
	    duration: num,
	    position: pst
    });
    toast.present();
    ToastAlert.toast = toast;
  }
  
  private handleError(error: any) {
        ToastAlert.toast=null;
  }   
  
  
}



// WEBPACK FOOTER //
// ./src/providers/util/toastalert.ts